export const CATALOG = {
  daycare: {
    label: 'Guardería', icon: '🌸',
    items: [
      { id: 'dc-day',   name: 'Día suelto',          price: 90,   unit: '/ día' },
      { id: 'dc-half',  name: 'Medio día',            price: 55,   unit: '/ visita' },
      { id: 'dc-10',    name: 'Pack 10 días',         price: 750,  unit: '/ pack', note: 'Ahorra $150' },
      { id: 'dc-20',    name: 'Pack 20 días',         price: 1400, unit: '/ pack', note: 'Ahorra $400' },
      { id: 'dc-month', name: 'Mes ilimitado',        price: 1600, unit: '/ mes' },
    ],
  },
  hotel: {
    label: 'Hotel', icon: '🏨', sized: true,
    items: [
      { id: 'h-std',  name: 'Habitación estándar', sizes: { S: 140, M: 180, L: 220, XL: 490 }, unit: '/ noche' },
      { id: 'h-walk', name: 'Paseo extra',         sizes: { S: 35,  M: 40,  L: 45,  XL: 50  }, unit: '/ paseo' },
    ],
  },
  vaccine: {
    label: 'Vacuna', icon: '💉',
    items: [
      { id: 'v-rabies',     name: 'Rabia',            price: 120, unit: '/ dosis' },
      { id: 'v-dhpp',       name: 'DHPP (5 en 1)',    price: 150, unit: '/ dosis' },
      { id: 'v-bordetella', name: 'Bordetella',       price: 110, unit: '/ dosis' },
      { id: 'v-lepto',      name: 'Leptospirosis',    price: 100, unit: '/ dosis' },
      { id: 'v-combo',      name: 'Combo anual',      price: 340, unit: '/ pack', note: 'Rabia + DHPP + Bord.' },
    ],
  },
  vet: {
    label: 'Veterinaria', icon: '🩺',
    items: [
      { id: 'vt-consult', name: 'Consulta',           price: 180, unit: '/ visita' },
      { id: 'vt-annual',  name: 'Revisión anual',     price: 280, unit: '/ visita' },
      { id: 'vt-follow',  name: 'Seguimiento',        price: 120, unit: '/ visita' },
      { id: 'vt-blood',   name: 'Panel de sangre',    price: 240, unit: '/ análisis' },
      { id: 'vt-dental',  name: 'Limpieza dental',    price: 560, unit: '/ sesión' },
    ],
  },
  grooming: {
    label: 'Estética', icon: '✂️',
    items: [
      { id: 'g-bath',    name: 'Baño',             price: 120, unit: '/ visita' },
      { id: 'g-cut',     name: 'Corte',            price: 200, unit: '/ sesión' },
      { id: 'g-hygcut',  name: 'Corte higiénico',  price: 150, unit: '/ sesión' },
      { id: 'g-deshed',  name: 'Deslanado',        price: 80,  unit: '/ sesión' },
      { id: 'g-medbath', name: 'Baño medicado',    price: 150, unit: '/ visita' },
      { id: 'g-color',   name: 'Colorimetría',     price: 200, unit: '/ sesión' },
    ],
  },
  other: { label: 'Otro', icon: '✏️', custom: true },
};

export const dogSize = (kg) => (!kg || kg <= 0 ? '?' : kg <= 10.9 ? 'S' : kg <= 20 ? 'M' : kg <= 35 ? 'L' : 'XL');
